(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stabraq-clothing-rail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stabraq-clothing-rail')) {
  customElements.define('stabraq-clothing-rail', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._items = [...this.querySelectorAll('[data-rail-item]')];
      this._viewport = this.querySelector('[data-rail-viewport]');
      this._track = this.querySelector('.stabraq-rail__track');
      this._hookOcclusion = this.querySelector('[data-rail-hook-occlusion]');
      if (!this._items.length || !this._viewport || !this._track) return;
      this._controller = new AbortController();
      this._signal = this._controller.signal;
      this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      this._smallScreen = window.matchMedia('(max-width: 749px)');
      this._active = 0;
      this._pointerStart = null;
      this._dragged = false;
      this._scrollTarget = null;
      this._scrollingAutomatic = false;
      this._normalizing = false;
      this._resizing = false;
      this._focused = false;
      this._hovered = false;
      this._selectionInitialized = false;
      this._visible = false;
      this._manualUntil = 0;
      this._userPaused = false;
      this._autoRunning = false;
      this._autoRaf = null;
      this._swayTime = 0;
      this._revealed = null;
      this._poseRaf = null;
      this._scrollSnapBefore = this._viewport.style.scrollSnapType;
      this._scrollBehaviorBefore = this._viewport.style.scrollBehavior;
      this._viewport.style.scrollSnapType = 'none';
      this._viewport.style.scrollBehavior = 'auto';
      this._previous = this.querySelector('[data-rail-prev]');
      this._next = this.querySelector('[data-rail-next]');
      this._counter = this.querySelector('[data-rail-counter]');
      this._autoplayButton = this.querySelector('[data-rail-autoplay]');
      this.classList.add('is-enhanced');
      this.querySelectorAll('[data-rail-open], [data-rail-navigation]').forEach(node => { node.hidden = false; });
      this._buildLoop();
      this._measureLayout();
      const listen = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal: this._signal });
      listen(this._viewport, 'pointerenter', event => {
        if (event.pointerType !== 'mouse' || this._smallScreen.matches || !this._desktopPointer.matches) return;
        this._hovered = true;
        this._scheduleAuto();
      });
      listen(this._viewport, 'pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        this._hovered = false;
        this._manualUntil = 0;
        if (!this._focused) this._reveal(this._smallScreen.matches ? this._active : null);
        this._scheduleAuto();
      });
      // Layout changes can move the hovered image without sending pointerleave.
      // Reconcile on the next real pointer event, including a released drag.
      listen(document, 'pointermove', event => {
        if (event.pointerType !== 'mouse') return;
        const hovered = !this._smallScreen.matches && this._desktopPointer.matches && this._viewport.contains(event.target);
        const released = this._pointerStart && event.buttons === 0;
        if (hovered === this._hovered && !released) return;
        this._hovered = hovered;
        if (released) {
          this._pointerStart = null;
          this._dragged = true;
          this._manualUntil = Date.now() + 1000;
        } else if (!hovered) this._manualUntil = 0;
        if (!hovered && !this._focused) this._reveal(this._smallScreen.matches ? this._active : null);
        this._scheduleAuto();
      }, { passive: true });
      listen(window, 'blur', () => {
        this._hovered = false;
        this._pointerStart = null;
        this._manualUntil = 0;
        if (!this._focused) this._reveal(this._smallScreen.matches ? this._active : null);
        this._scheduleAuto();
      });
      listen(window, 'focus', () => {
        this._focused = this.contains(document.activeElement) && document.activeElement !== this._autoplayButton && document.activeElement.matches(':focus-visible');
        this._hovered = !this._smallScreen.matches && this._desktopPointer.matches && this._viewport.matches(':hover');
        if (!this._hovered && !this._focused) this._reveal(this._smallScreen.matches ? this._active : null);
        this._scheduleAuto();
      });
      listen(this._desktopPointer, 'change', () => {
        this._hovered = false;
        this._scheduleAuto();
      });
      listen(this, 'pointerover', event => {
        if (event.pointerType !== 'mouse' || this._smallScreen.matches || !this._desktopPointer.matches || this._quickViewOpen || this._resizing) return;
        const card = this._cardFor(event.target);
        if (card) {
          this._select(Number(card.dataset.railIndex));
          this._reveal(Number(card.dataset.railIndex));
        } else if (this._viewport.contains(event.target) && !this._focused) this._reveal(null);
      });
      listen(this, 'focusin', event => {
        this._focused = event.target !== this._autoplayButton && event.target.matches(':focus-visible');
        this._scheduleAuto();
        const card = this._cardFor(event.target);
        if (card) {
          this._select(Number(card.dataset.railIndex), true);
          if (this._focused || this._hovered || this._smallScreen.matches) this._reveal(Number(card.dataset.railIndex));
        }
      });
      listen(this, 'focusout', () => {
        queueMicrotask(() => {
          if (!this._controller) return;
          this._focused = this.contains(document.activeElement) && document.activeElement !== this._autoplayButton && document.activeElement.matches(':focus-visible');
          if (!this._focused && !this._hovered) this._reveal(this._smallScreen.matches ? this._active : null);
          this._scheduleAuto();
        });
      });
      listen(this._viewport, 'pointerdown', event => {
        this._pointerStart = { x: event.clientX, y: event.clientY };
        this._dragged = false;
        this._scrollTarget = null;
        this._scrollingAutomatic = false;
        clearTimeout(this._scrollTimer);
        this._manualPause();
      }, { passive: true });
      listen(this._viewport, 'pointermove', event => {
        if (!this._pointerStart) return;
        if (Math.hypot(event.clientX - this._pointerStart.x, event.clientY - this._pointerStart.y) > 12) this._dragged = true;
      }, { passive: true });
      listen(window, 'pointercancel', () => { if (!this._pointerStart) return; this._pointerStart = null; this._dragged = true; this._manualPause(); });
      listen(window, 'pointerup', () => { if (!this._pointerStart) return; this._pointerStart = null; this._manualPause(); });
      listen(this._viewport, 'wheel', () => this._manualPause(), { passive: true });
      listen(this, 'click', event => {
        const select = event.target.closest('[data-rail-select]');
        const open = event.target.closest('[data-rail-open]');
        if (select || open) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
          const card = this._cardFor(select || open);
          if (!card) return;
          event.preventDefault();
          if (this._dragged && event.detail > 0) { this._dragged = false; return; }
          const index = Number(card.dataset.railIndex);
          this._manualPause();
          this._select(index, true);
          this._normalizeClone(card);
          const nativeOpener = this._items[index].querySelector(open ? '[data-rail-open]' : '[data-rail-select]');
          this._open(this._items[index], nativeOpener);
        }
      });
      listen(this._previous, 'click', () => this._move(-1));
      listen(this._next, 'click', () => this._move(1));
      listen(this._autoplayButton, 'click', () => {
        this._userPaused = !this._userPaused;
        this._manualUntil = 0;
        this._updateAutoplayControl();
        this._scheduleAuto();
      });
      listen(this._viewport, 'scroll', () => {
        if (this._autoRunning) return;
        if (this._resizing || this._normalizing) return;
        if (Math.abs(this._viewport.clientWidth - this._viewportWidth) >= 1 && this._preserveSelectionOnResize()) return;
        if (!this._scrollTarget) this._manualPause();
        if (this._frame) return;
        this._frame = requestAnimationFrame(() => {
          this._frame = null;
          if (this._resizing || this._normalizing) return;
          if (Math.abs(this._viewport.clientWidth - this._viewportWidth) >= 1 && this._preserveSelectionOnResize()) return;
          this._paintMotion();
          if (this._scrollTarget) {
            const viewport = this._viewport.getBoundingClientRect();
            const target = this._scrollTarget.getBoundingClientRect();
            if (Math.abs(target.left + target.width / 2 - viewport.left - viewport.width / 2) > 8) return;
            this._finishScroll();
            return;
          }
          const nearest = this._nearestCard();
          if (nearest) this._select(Number(nearest.dataset.railIndex));
          clearTimeout(this._settleTimer);
          this._settleTimer = setTimeout(() => this._finishScroll(), 180);
        });
      }, { passive: true });
      listen(this._viewport, 'scrollend', () => this._finishScroll());
      this._quickView = document.getElementById('QuickViewStandard');
      this._quickViewOpen = Boolean(this._quickView?.hasAttribute('open'));
      if (this._quickView) {
        this._quickViewObserver = new MutationObserver(() => {
          this._quickViewOpen = this._quickView.hasAttribute('open') || this._nativeOpener?.getAttribute('aria-disabled') === 'true';
          this._scheduleAuto();
        });
        this._quickViewObserver.observe(this._quickView, { attributes: true, attributeFilter: ['open'] });
        this._quickViewObserver.observe(this, { attributes: true, subtree: true, attributeFilter: ['aria-disabled'] });
      }
      listen(document, 'visibilitychange', () => this._scheduleAuto());
      listen(this._reducedMotion, 'change', () => {
        this._updateAutoplayControl();
        this._scheduleAuto();
        this._paintMotion();
      });
      listen(document, 'shopify:block:select', event => {
        const index = this._items.findIndex(item => item.dataset.blockId === event.detail.blockId);
        if (index !== -1) {
          this._manualPause();
          this._select(index, true);
          this._scrollToNode(this._items[index]);
        }
      });
      this._resizeObserver = new ResizeObserver(() => {
        this._preserveSelectionOnResize();
        this.classList.toggle('has-overflow', this._viewport.scrollWidth > this._viewport.clientWidth + 8);
      });
      this._resizeObserver.observe(this._viewport);
      this._resizeObserver.observe(this._track);
      this._resizeObserver.observe(this.querySelector('.stabraq-rail__bar'));
      this._visibilityObserver = new IntersectionObserver(entries => {
        this._visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
        this._scheduleAuto();
      }, { threshold: [0, .25] });
      this._visibilityObserver.observe(this);
      this._select(0);
      this._updateAutoplayControl();
      this._scrollToNode(this._items[0], true);
    }
    disconnectedCallback() {
      this._stopContinuous();
      this._stopPose();
      this._controller?.abort();
      this._controller = null;
      if (this._frame) cancelAnimationFrame(this._frame);
      if (this._normalizationFrame) cancelAnimationFrame(this._normalizationFrame);
      if (this._resizeFrame) cancelAnimationFrame(this._resizeFrame);
      this._frame = null;
      this._normalizationFrame = null;
      this._resizeFrame = null;
      clearTimeout(this._scrollTimer);
      clearTimeout(this._settleTimer);
      clearTimeout(this._autoTimer);
      this._resizeObserver?.disconnect();
      this._visibilityObserver?.disconnect();
      this.querySelectorAll('[data-rail-clone]').forEach(node => node.remove());
      if (this._viewport) {
        this._viewport.style.scrollSnapType = this._scrollSnapBefore || '';
        this._viewport.style.scrollBehavior = this._scrollBehaviorBefore || '';
      }
      this._quickViewObserver?.disconnect();
    }
    _buildLoop() {
      this._items.forEach((item, index) => { item.dataset.railIndex = String(index); });
      this._beforeClones = [];
      this._afterClones = [];
      if (this._items.length > 1) {
        const cloneItem = item => {
          const clone = item.cloneNode(true);
          clone.removeAttribute('data-rail-item');
          clone.removeAttribute('data-shopify-editor-block');
          clone.removeAttribute('data-block-id');
          clone.dataset.railClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('template').forEach(node => node.remove());
          clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          clone.querySelectorAll('[data-rail-select], [data-rail-open]').forEach(node => {
            const visual = document.createElement('span');
            visual.className = node.className;
            if (node.hasAttribute('data-rail-open')) visual.dataset.railOpen = '';
            else visual.dataset.railSelect = '';
            visual.style.cursor = 'pointer';
            visual.replaceChildren(...node.childNodes);
            node.replaceWith(visual);
          });
          clone.querySelectorAll('[tabindex]').forEach(node => node.removeAttribute('tabindex'));
          clone.querySelectorAll('a, button').forEach(node => node.setAttribute('tabindex', '-1'));
          clone.querySelectorAll('img').forEach(node => { node.loading = 'lazy'; });
          return clone;
        };
        this._beforeClones = this._items.map(cloneItem);
        this._afterClones = this._items.map(cloneItem);
        this._track.prepend(...this._beforeClones);
        this._track.append(...this._afterClones);
      }
      this._cards = [...this._beforeClones, ...this._items, ...this._afterClones];
      this._motionCards = this._cards.map(card => ({
        card,
        arc: card.querySelector('.stabraq-rail__arc'),
        swing: card.querySelector('.stabraq-rail__swing'),
        index: Number(card.dataset.railIndex),
        visible: false,
        offset: 0,
        targetOffset: 0
      }));
    }
    _cardFor(node) {
      return node.closest('[data-rail-item], [data-rail-clone]');
    }
    _measureLayout() {
      const sceneScale = this._smallScreen.matches ? .72 : Math.min(1.4, Math.max(.84, this._viewport.clientWidth / 1360));
      this._sceneScale = sceneScale;
      this.style.setProperty('--rail-scene-scale', sceneScale.toFixed(3));
      const viewport = this._viewport.getBoundingClientRect();
      const scrollLeft = this._viewport.scrollLeft;
      this._viewportWidth = this._viewport.clientWidth;
      this._itemWidth = this._items[0].getBoundingClientRect().width;
      this._curveDepth = this.querySelector('.stabraq-rail__bar').getBoundingClientRect().height;
      this._cardCenters = new Map(this._cards.map(card => {
        const rect = card.getBoundingClientRect();
        return [card, rect.left - viewport.left + scrollLeft + rect.width / 2];
      }));
      this._updateSpreadTargets();
      this._paintMotion(scrollLeft);
    }
    _reveal(index) {
      if (this._revealed === index) return;
      this._revealed = index;
      this._cards.forEach(card => card.classList.toggle('is-revealed', index !== null && Number(card.dataset.railIndex) === index));
      this._updateSpreadTargets();
      this._schedulePose();
    }
    _updateSpreadTargets() {
      if (!this._cardCenters || !this._motionCards) return;
      const anchors = this._revealed === null ? [] : this._motionCards.filter(motion => motion.index === this._revealed).map(motion => this._cardCenters.get(motion.card));
      const gap = this._smallScreen.matches ? 26 : Math.min(88, this._itemWidth * .45);
      this._motionCards.forEach(motion => {
        motion.targetOffset = 0;
        if (!anchors.length || motion.index === this._revealed) return;
        const center = this._cardCenters.get(motion.card);
        let delta = Infinity;
        anchors.forEach(anchor => { if (Math.abs(center - anchor) < Math.abs(delta)) delta = center - anchor; });
        const influence = Math.max(0, 1 - (Math.abs(delta) / this._itemWidth - 1) / 3);
        motion.targetOffset = Math.sign(delta) * gap * Math.min(1, influence);
      });
    }
    _advanceSpread(elapsed) {
      let unsettled = false;
      const blend = this._reducedMotion.matches ? 1 : 1 - Math.exp(-elapsed / 95);
      this._motionCards.forEach(motion => {
        motion.offset += (motion.targetOffset - motion.offset) * blend;
        if (Math.abs(motion.targetOffset - motion.offset) < .08) motion.offset = motion.targetOffset;
        else unsettled = true;
      });
      return unsettled;
    }
    _stopPose() {
      if (this._poseRaf) cancelAnimationFrame(this._poseRaf);
      this._poseRaf = null;
    }
    _schedulePose() {
      this._stopPose();
      if (this._reducedMotion.matches) {
        this._advanceSpread(0);
        this._paintMotion();
        return;
      }
      if (this._autoRunning || !this._controller || this._resizing || !this._visible || document.hidden || this._quickViewOpen || this._pointerStart) return;
      if (!this._motionCards.some(motion => motion.offset !== motion.targetOffset)) return;
      let last = 0;
      const settle = timestamp => {
        this._poseRaf = null;
        if (this._autoRunning || !this._controller || this._resizing || !this._visible || document.hidden || this._quickViewOpen || this._pointerStart) return;
        const elapsed = last ? Math.min(64, timestamp - last) : 16;
        last = timestamp;
        const unsettled = this._advanceSpread(elapsed);
        this._paintMotion();
        if (unsettled) this._poseRaf = requestAnimationFrame(settle);
      };
      this._poseRaf = requestAnimationFrame(settle);
    }
    _paintMotion(scrollLeft = this._viewport.scrollLeft) {
      if (!this._viewportWidth || !this._motionCards) return;
      const halfWidth = this._viewportWidth / 2;
      const amplitude = this._smallScreen.matches ? 1.4 : 2.2;
      const occlusionBands = [];
      const svgScale = 1000 / this._viewportWidth;
      const hookScale = this._sceneScale || 1;
      this._motionCards.forEach(motion => {
        const x = this._cardCenters.get(motion.card) - scrollLeft + motion.offset;
        const visible = x >= -this._itemWidth && x <= this._viewportWidth + this._itemWidth;
        if (visible !== motion.visible) {
          motion.visible = visible;
          motion.arc.style.willChange = visible ? 'transform' : '';
          motion.swing.style.willChange = visible ? 'transform' : '';
        }
        if (!visible) return;
        const u = Math.max(-1, Math.min(1, (x - halfWidth) / halfWidth));
        const drop = this._curveDepth * (1 - u * u);
        const phase = this._swayTime * Math.PI * 2 / (4200 + motion.index % 5 * 220) + motion.index * 1.37;
        const angle = this._reducedMotion.matches ? 0 : Math.sin(phase) * amplitude;
        const sway = angle * Math.PI / 180;
        const hookX = x + Math.sin(sway) * 4 * hookScale;
        const left = (hookX - 12 * hookScale) * svgScale;
        const right = (hookX - .4 * hookScale) * svgScale;
        occlusionBands.push(`M${left.toFixed(3)} -20H${right.toFixed(3)}V120H${left.toFixed(3)}Z`);
        const arcTransform = `translate3d(${motion.offset.toFixed(2)}px, ${drop.toFixed(2)}px, 0)`;
        const swingTransform = `rotate(${angle.toFixed(3)}deg)`;
        if (motion.arc.style.transform !== arcTransform) motion.arc.style.transform = arcTransform;
        if (motion.swing.style.transform !== swingTransform) motion.swing.style.transform = swingTransform;
      });
      const occlusion = occlusionBands.join('');
      if (this._hookOcclusion && this._lastOcclusion !== occlusion) {
        this._hookOcclusion.setAttribute('d', occlusion);
        this._lastOcclusion = occlusion;
      }
    }
    _nearestCard() {
      const center = (this._autoRunning ? this._autoPosition : this._viewport.scrollLeft) + this._viewportWidth / 2;
      let nearest = null;
      let distance = Infinity;
      this._cardCenters.forEach((cardCenter, card) => {
        const candidate = Math.abs(cardCenter - center);
        if (candidate < distance) { distance = candidate; nearest = card; }
      });
      return nearest;
    }
    _select(index, announce = false) {
      if (index < 0 || index >= this._items.length) return;
      if (this._selectionInitialized && index === this._active && !announce) return;
      this._selectionInitialized = true;
      this._active = index;
      if (this._smallScreen.matches) this._reveal(index);
      this._cards.forEach(card => card.classList.toggle('is-active', Number(card.dataset.railIndex) === index));
      if (this._previous) this._previous.disabled = this._items.length < 2;
      if (this._next) this._next.disabled = this._items.length < 2;
      if (this._counter) {
        this._counter.setAttribute('aria-live', announce ? 'polite' : 'off');
        const nextCounter = `${index + 1} / ${this._items.length}`;
        if (this._counter.textContent !== nextCounter) this._counter.textContent = nextCounter;
      }
    }
    _move(direction, automatic = false) {
      if (this._items.length < 2) return;
      if (this._preserveSelectionOnResize() || this._resizing) return;
      if (!automatic) this._manualPause();
      this._normalizeClone(this._nearestCard());
      const previous = this._active;
      const next = (previous + direction + this._items.length) % this._items.length;
      let target = this._items[next];
      if (previous === this._items.length - 1 && direction > 0) target = this._afterClones[0];
      if (previous === 0 && direction < 0) target = this._beforeClones[this._items.length - 1];
      this._scrollingAutomatic = automatic;
      this._select(next, !automatic);
      this._scrollToNode(target);
    }
    _scrollToNode(node, instant = false) {
      if (!node) return;
      const viewport = this._viewport.getBoundingClientRect();
      const item = node.getBoundingClientRect();
      this._scrollTarget = node;
      clearTimeout(this._scrollTimer);
      clearTimeout(this._settleTimer);
      this._scrollTimer = setTimeout(() => this._finishScroll(), 900);
      this._viewport.scrollBy({ left: item.left + item.width / 2 - viewport.left - viewport.width / 2, behavior: instant || this._reducedMotion.matches ? 'instant' : 'smooth' });
      this._paintMotion();
    }
    _finishScroll() {
      if (!this._controller || this._autoRunning || this._resizing || this._normalizing || this._pointerStart) return;
      clearTimeout(this._scrollTimer);
      clearTimeout(this._settleTimer);
      this._scrollTarget = null;
      this._scrollingAutomatic = false;
      const nearest = this._nearestCard();
      if (nearest) {
        this._select(Number(nearest.dataset.railIndex));
        this._normalizeClone(nearest);
      }
      this._scheduleAuto();
    }
    _normalizeClone(card) {
      if (!card?.hasAttribute('data-rail-clone')) return;
      const original = this._items[Number(card.dataset.railIndex)];
      const delta = this._cardCenters.get(original) - this._cardCenters.get(card);
      this._normalizing = true;
      this._viewport.scrollBy({ left: delta, behavior: 'instant' });
      this._paintMotion();
      if (this._normalizationFrame) cancelAnimationFrame(this._normalizationFrame);
      this._normalizationFrame = requestAnimationFrame(() => {
        this._normalizing = false;
        this._normalizationFrame = null;
        this._scheduleAuto();
      });
    }
    _preserveSelectionOnResize() {
      const width = this._viewport.clientWidth;
      const itemWidth = this._items[0].getBoundingClientRect().width;
      const curveDepth = this.querySelector('.stabraq-rail__bar').getBoundingClientRect().height;
      if (Math.abs(width - this._viewportWidth) < 1 && Math.abs(itemWidth - this._itemWidth) < 1 && Math.abs(curveDepth - this._curveDepth) < .1) return false;
      this._viewportWidth = width;
      this._itemWidth = itemWidth;
      const index = this._active;
      this._resizing = true;
      this._stopContinuous();
      this._stopPose();
      this._scrollTarget = null;
      clearTimeout(this._autoTimer);
      clearTimeout(this._scrollTimer);
      clearTimeout(this._settleTimer);
      if (this._frame) cancelAnimationFrame(this._frame);
      if (this._resizeFrame) cancelAnimationFrame(this._resizeFrame);
      this._frame = null;
      this._resizeFrame = requestAnimationFrame(() => {
        if (!this._controller) return;
        this._measureLayout();
        this._hovered = !this._smallScreen.matches && this._desktopPointer.matches && this._viewport.matches(':hover');
        this._select(index);
        this._reveal(this._smallScreen.matches || this._hovered || this._focused ? index : null);
        this._scrollToNode(this._items[index], true);
        this._resizeFrame = requestAnimationFrame(() => {
          this._resizeFrame = null;
          this._resizing = false;
          this._finishScroll();
          this._scheduleAuto();
        });
      });
      return true;
    }
    _manualPause() {
      this._manualUntil = Date.now() + 1000;
      this._scheduleAuto();
    }
    _scheduleAuto() {
      clearTimeout(this._autoTimer);
      if (!this._canAuto()) {
        this._stopContinuous();
        this._schedulePose();
        return;
      }
      const remaining = this._manualUntil - Date.now();
      if (remaining > 0) {
        this._stopContinuous();
        this._schedulePose();
        this._autoTimer = setTimeout(() => this._scheduleAuto(), remaining);
        return;
      }
      this._startContinuous();
    }
    _canAuto() {
      return Boolean(this._controller && !this._resizing && this._items.length > 1 && !this._userPaused && !this._reducedMotion.matches && !this._focused && !this._hovered && !this._quickViewOpen && !this._scrollTarget && !this._pointerStart && this._visible && !document.hidden);
    }
    _startContinuous() {
      if (this._autoRunning) return;
      this._stopPose();
      this._autoRunning = true;
      this.classList.add('is-autoplaying');
      this._autoPosition = this._viewport.scrollLeft;
      this._autoLastTime = 0;
      this._autoLastSelection = 0;
      const direction = getComputedStyle(this._track).direction === 'rtl' ? -1 : 1;
      const tick = timestamp => {
        this._autoRaf = null;
        if (!this._canAuto() || this._manualUntil > Date.now()) {
          this._scheduleAuto();
          return;
        }
        const elapsed = this._autoLastTime ? Math.min(64, timestamp - this._autoLastTime) : 0;
        this._autoLastTime = timestamp;
        this._swayTime += elapsed;
        this._advanceSpread(elapsed);
        this._autoPosition += direction * 48 * elapsed / 1000;
        this._viewport.scrollLeft = this._autoPosition;
        if (timestamp - this._autoLastSelection >= 120) {
          this._autoLastSelection = timestamp;
          const nearest = this._nearestCard();
          if (nearest) {
            const index = Number(nearest.dataset.railIndex);
            if (index !== this._active) this._select(index);
            if (nearest.hasAttribute('data-rail-clone')) {
              this._normalizeClone(nearest);
              this._autoPosition = this._viewport.scrollLeft;
            }
          }
        }
        this._paintMotion();
        this._autoRaf = requestAnimationFrame(tick);
      };
      this._autoRaf = requestAnimationFrame(tick);
    }
    _stopContinuous() {
      if (this._autoRaf) cancelAnimationFrame(this._autoRaf);
      this._autoRaf = null;
      this._autoRunning = false;
      this.classList.remove('is-autoplaying');
    }
    _updateAutoplayControl() {
      if (!this._autoplayButton) return;
      this._autoplayButton.hidden = this._items.length < 2 || this._reducedMotion.matches;
      this._autoplayButton.setAttribute('aria-pressed', String(this._userPaused));
      const label = this._userPaused ? this._autoplayButton.dataset.playLabel : this._autoplayButton.dataset.pauseLabel;
      if (label) this._autoplayButton.setAttribute('aria-label', label);
      const pauseIcon = this._autoplayButton.querySelector('[data-rail-pause-icon]');
      const playIcon = this._autoplayButton.querySelector('[data-rail-play-icon]');
      if (pauseIcon) pauseIcon.hidden = this._userPaused;
      if (playIcon) playIcon.hidden = !this._userPaused;
    }
    _open(item, opener) {
      if (this._quickViewOpen || !opener) return;
      const modal = document.getElementById('QuickViewStandard');
      if (!modal || typeof modal.show !== 'function') {
        window.location.assign(item.querySelector('[data-rail-select]').href);
        return;
      }
      this._nativeOpener = opener;
      this._quickViewOpen = true;
      this._scheduleAuto();
      modal.show(opener);
    }

  });
}

  } catch(e) { console.error(e); }
})();
})();
